import React, { Component } from 'react'
import CalendarCell from './CalendarCell'
import Reader from '../../controller/Reader'


export default class CalendarBody extends Component {

    constructor() {
        super()
        this.state = {
            dateArr: [],
            foreDummy: [],
            afterDummy: [],
            isOverflow: true,
            taskData: []
        }
    }


    componentWillReceiveProps(nextProps) {

        let first = new Date(nextProps.year, nextProps.month)
        let last = new Date(nextProps.year, nextProps.month + 1, 0)

        const condition = {
            url : '/api/calendar/list/' + nextProps.year + '/' + nextProps.month
        }
        	
        Reader(condition, res => {

            if(res.data !== null) {
                this.setState({ taskData : res.data })
            } 

        })

        this.changeDate(first, last)
    }

    changeDate = (first, last) => {

        let firstDay = first.getDay()
        let lastDay = last.getDay()
        let lastDate = last.getDate()

        let foreDummy = []
        let afterDummy = []
        let dateArr = []

        for(let i=0; i < firstDay ; i++) {

            foreDummy.push(i)

        }

        for(let i=0; i < 6- lastDay; i++) {
            
            afterDummy.push(i)

        }

        for(let i=0; i < lastDate; i++) {

            dateArr.push(i)

        }

        this.setState({
            foreDummy: foreDummy,
            afterDummy: afterDummy,
            dateArr: dateArr
        })

        let length = foreDummy.length + afterDummy.length + dateArr.length

        length > 35 ? this.setState({ isOverflow : true }) : this.setState({ isOverflow : false })


    }


    render() {

        let pushDate = this.state.dateArr.map( val => {

            let filtIt = this.state.taskData.filter( data => { 

                return data.date === val

            })

            let taskArray = filtIt.map( bar => {
                
                return bar.task
            
            })

            let taskString = taskArray.toString()
            
            return(

                <CalendarCell
                    year = { this.props.year }
                    month = { this.props.month }
                    date = { val + 1 }
                    plan = { taskString }
                    isOverflow = { this.state.isOverflow }
                />
            )
        })


        let foreDays = this.state.foreDummy.map( () => {

            return(

                <div className={ this.state.isOverflow? 'DummyCell2' : 'DummyCell'} >

	                <span></span>
                
                </div> 
            )
        })


        let afterDays = this.state.afterDummy.map( () => {
    
                return(
                	
	                <div className={ this.state.isOverflow? 'DummyCell2' : 'DummyCell'} >
		                <span></span>
	                </div> 
            )
        })

        
        const Title = () => {

            return(
            
                <React.Fragment>

                    <div className='DayCell'><span>SUN</span></div> 
                    <div className='DayCell'><span>MON</span></div> 
                    <div className='DayCell'><span>TUE</span></div> 
                    <div className='DayCell'><span>WEN</span></div> 
                    <div className='DayCell'><span>THU</span></div> 
                    <div className='DayCell'><span>FRI</span></div> 
                    <div className='DayCell'><span>SAT</span></div> 

                </React.Fragment>
            )
        }

        return(
        	
            <div id='CalBody'>

                <Title />
                
                { foreDays }
                { pushDate }
                { afterDays }

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/calendar/CalendarBody.js